// extracted by mini-css-extract-plugin
export default {"bar":"ScriptBulkAttachFooter_bar__Y6KXd","button":"ScriptBulkAttachFooter_button__mwndg","attachButton":"ScriptBulkAttachFooter_attachButton__DAy1t"};